import React from 'react';

function featuredImage(props) {
    const { image, imageSize } = props;

    let imgTag = '';
    const srcset =
        props.srcSet && props.srcSet[imageSize] ? props.srcSet[imageSize] : '';

    if (image && image[0].media_details) {
        const imageSizeDetails =
            image[0].media_details.sizes[imageSize] ||
            image[0].media_details.sizes['full'];
        imgTag = (
            <img
                src={imageSizeDetails.source_url}
                srcSet={srcset}
                alt={image[0].title.rendered}
            />
        );
    }

    return imgTag;
}

export default featuredImage;
